<template>
  <div
    :class="$style.root"
    ref="rootElement"
    @keydown.esc="closeSelf"
    tabindex="0"
  >
    <LayoutStickyHeaderComponent :class="$style.nav">
      <I18nLink
        :to="parentRoute"
        :class="$style.linkToClose"
      >
        <LayoutTextWithBarComponent>{{ $t('shared.close') }}</LayoutTextWithBarComponent>
      </I18nLink>

      <NavigationLanguageSwitcherComponent :sticky="true" />
    </LayoutStickyHeaderComponent>

    <slot />

    <client-only>
      <LayoutModalNextComponent :class="$style.linkToNext" />
    </client-only>
  </div>
</template>

<script setup>
const route = useRoute()
const localePath = useLocalePath()

const props = defineProps({
  parentRoute: {
    type: [String, Object],
    default: true,
  }
})

const rootElement = ref(null)
const router = useRouter()

const closeSelf = () => {
  router?.push(localePath(props?.parentRoute))
}

onClickOutside(rootElement, () => {
  closeSelf()
}, {ignore: ['a', 'button', '#fence']})


onMounted(() => {
  setTimeout(() => {
    document.documentElement.toggleAttribute('data-overflow-hidden', true)
    rootElement.value.focus()
  }, 50)
})

onBeforeUnmount(() => {
  if (process.client) {
    document.documentElement.removeAttribute('data-overflow-hidden', '')
  }
})
</script>

<style module lang=scss>
.root {
  position: fixed;
  z-index: var(--z-index--modal);
  top: 0;
  bottom: 0;
  right: 0;
  width: 50vw;

  background-color: var(--color--pink--light);

  border-left: var(--stroke--thick) solid var(--color--black);

  padding: 0 var(--unit--horizontal) calc(var(--unit--vertical--double) * 2 + var(--unit--vertical)) var(--unit--horizontal);

  overflow: scroll;

  display: flex;
  flex-direction: column;

  --unit--horizontal--tripple: var(--unit--horizontal);

  @media (max-width: $breakpoint-m) {
    width: 75vw;
  }

  @media (max-width: $breakpoint-s) {
    width: 100vw;
    border-left: none;
  }
}

.root:focus {
  outline: none;
}

.nav {
  display: flex;
  justify-content: flex-end;
  gap: var(--unit--horizontal);
  margin-bottom: var(--unit--spacer);

  padding-left: 0;
  padding-right: 0;
}

.linkToNext {
  margin-top: auto;
  margin-left: auto;
  display: inline-block;

  margin-top: var(--unit--vertical--tripple);
}

.linkToClose:hover {
  color: var(--color--pink);
}
</style>
